import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useAluno } from "@/hooks/alunos";
import { Button } from "@/components/Common";

import api, { makeOptions } from "@/services/api";
import toastify from "@/services/toastify";

import { ModalContent, ModalFooter } from "./styles";

export default function ModalDeleteCurso({ onClose, id }) {
  const { data: user } = useSelector(state => state.auth);
  const [loading, setLoading] = useState(false);
  const { aluno, fetchAluno } = useAluno();

  async function deleteCurso() {
    setLoading(true);
    const endpoint = `alunos/curriculos/cursos-complementares/${id}`;
    const { data: response } = await api.delete(
      endpoint,
      makeOptions(user)
    );
    setLoading(false);
    if (response.success) {
      toastify("Curso complementar removido com sucesso");
      fetchAluno(aluno.id);
      onClose();
    }
  }

  return (
    <ModalContent>
      <h2>Remover este curso complementar?</h2>
      <ModalFooter>
        <Button variant="cancel" onClick={() => onClose()}>
          Cancelar
        </Button>
        <Button
          variant="tangerine"
          onClick={deleteCurso}
          loading={loading || undefined}
        >
          Remover
        </Button>
      </ModalFooter>
    </ModalContent>
  );
}
